<template>
  <mdb-container class="gp-has-header" v-if="groupInfo">
    <mdb-card class="text-left mb-4">
      <mdb-card-header class="text-white">
        <h5>{{ groupInfo.name }} Guided Setup</h5>
      </mdb-card-header>

      <mdb-card-body class="text-left">
        <div v-if="currentView == 'finalize'" class="text-info">
          Congratulations! You have completed all the basic steps to set up your group. You may re-visit any of the
          steps by clicking
          any of the links below.
        </div>

        <div v-if="currentView == 'menu'" class="text-info">
          You have already completed the guided set up, but you can re-visit any of the steps by clicking any of the
          buttons below.
        </div>

        <div>
          <mdb-btn v-if="currentView == 'finalize'" @click="groupHome" icon="home"> Go to your new group now</mdb-btn>
        </div>


        <div v-if="currentView == 'menu' || currentView == 'finalize'">
          <mdb-card class="mb-4">
            <mdb-card-header>Banner</mdb-card-header>
            <mdb-card-body>
              <div class="group-banner group-banner-large mb-4"
                   v-bind:style="'background-image: url(\'' + checklist.banner + '\');'">
                <div class="group-overlay-container text-left">
                  {{ groupInfo.name }}
                </div>
              </div>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn @click="currentView = 'banner'" icon="pencil">Change</mdb-btn>
            </mdb-card-footer>
          </mdb-card>


          <h3>Group Image</h3>
          <mdb-row>
            <div class="col-md-3 d-flex align-self-stretch">
              <mdb-card class="face front mb-4 animated rotateIn">
                <mdb-view hover zoom>
                  <mdb-card-image
                    :src="checklist.avatar"
                    alt="Card image cap"
                  ></mdb-card-image>
                  <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                </mdb-view>
                <mdb-card-body class="text-center">
                  <mdb-btn @click="currentView = 'avatar'" icon="pencil">Change</mdb-btn>
                </mdb-card-body>
              </mdb-card>
            </div>
          </mdb-row>

          <mdb-card class="mb-4">
            <mdb-card-header>Categories</mdb-card-header>
            <mdb-card-body>
              <cust-chip-input prompt="" disabled :chips="categoryTags" id="chip-input"/>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn @click="currentView = 'categories'" icon="pencil">Change</mdb-btn>
            </mdb-card-footer>
          </mdb-card>

          <router-link :to="'/group/'+ groupInfo.vanityPath">{{ groupInfo.name }} Home Page</router-link>
        </div>

        <div v-if="currentView=='avatar'">
          <p>Please set an image that will be used to identify your group on your members' home page,
            in group emails and other places your group is displayed.
          </p>

          <div v-if="showUploadedAvatar">
            <mdb-row>
              <div class="col-md-3 d-flex align-self-stretch">
                <mdb-card class="face front mb-4 animated rotateIn">
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="avatarUrl"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                  <mdb-card-body class="text-center">
                    <mdb-btn @click="acceptAvatar" icon="check"
                             size="sm"
                             color="success"
                             type=""> Use This One
                    </mdb-btn>
                    <mdb-btn @click="rejectAvatar" icon="minus-circle"
                             size="sm"
                             color="danger"
                             type=""> Try again
                    </mdb-btn>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>

          </div>
          <div v-if="!showUploadedAvatar">

            <p>
              <mdb-btn @click="openUpload('avatar')">Upload Your Own</mdb-btn>
            </p>

            <mdb-row>
              <div :id="'image-'+i" :key="i" class="col-md-3 d-flex align-self-stretch" v-for="i in 50">
                <mdb-card class="face front mb-4 animated rotateIn">
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="settings.staticImageUrl + '/default_group_avatar_' + i + '.jpg'"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                  <mdb-card-body class="text-center">
                    <mdb-btn @click="setGenericAvatar(i)" icon="check"
                             size="sm"
                             type=""> Select
                    </mdb-btn>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </div>
        </div>

        <div v-if="currentView == 'banner'">
          <h3>
            Click your group's name below to select the banner you wish to use for you home page.
          </h3>

          <p>
            <mdb-btn @click="openUpload('banner')">Upload A New Image</mdb-btn>
          </p>

          <div v-if="banners">
            <div v-bind:id="banner.id" v-for="banner in banners.customImages">
              <div class="group-banner group-banner-large mb-4"
                   v-bind:style="'background-image: url(\'' + banner.url + '\');'">
                <div class="group-overlay-container text-left">
                  <a @click="selectBanner('custom',banner)" role="button">{{ groupInfo.name }}</a>
                </div>
              </div>
            </div>
            <div v-bind:id="banner.id" v-for="banner in banners.defaultImages">
              <div class="group-banner group-banner-large mb-4"
                   v-bind:style="'background-image: url(\'' + banner.url + '\');'">
                <div class="group-overlay-container text-left">
                  <a @click="selectBanner('default',banner)" role="button">{{ groupInfo.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentView == 'categories'">

          <mdb-row>
            <mdb-col col="12">
              <h3>Categories</h3>
              <div class="text-info">
                <p>Category tags help others looking for your group to find you. Enter words or phrases that people
                  might search for.</p>
                <p>For example, if you are a hiking group, enter tags like "hike, hiking, hiking group, walking"</p>
              </div>
              <cust-chip-input :chips="categoryTags" id="chip-input"/>
              <mdb-btn icon="save" :disabled="categoryTags.length ==0" @click="saveTags">Save</mdb-btn>
            </mdb-col>
          </mdb-row>

        </div>

        <mdb-btn size="sm"
                 v-if="checklist && !checklist.showChecklist && currentView != 'menu' && currentView != 'finalize'"
                 @click="currentView='menu'">Cancel
        </mdb-btn>

      </mdb-card-body>
    </mdb-card>

    <mdb-modal v-if="showUpload " size="lg" @close="showUpload=false">
      <mdb-modal-header :close="true">
        <h1>{{ $t("common.label.uploadImage") }}</h1>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-file-input v-on:getValue="uploadFile"/>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbView
} from 'mdbvue';

import VueRecaptcha from 'vue-recaptcha';
import Banner from "./Banner.vue";
import {custChipInput} from "../common/CustChipInput";

export default {
  name: 'Group-Setup',
  components: {
    mdbCol, custChipInput,
    mdbFileInput,
    mdbMask, mdbRow, mdbView, mdbBadge, mdbCardImage,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbIcon,
    mdbCardHeader,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbContainer,
    VueRecaptcha,
    Banner
  },
  computed: {
    apiKey: function () {
      return this.$store.state.apiKey
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    loggedIn: function () {
      return this.$store.state.loggedIn
    },
    settings: function () {
      return this.$store.state.settings
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    }
  },
  data() {
    return {
      groupInfo: null,
      checklist: null,
      banners: null,
      showUpload: false,
      uploadType: null,
      showUploadedAvatar: false,
      avatarUrl: null,
      currentView: null,
      categoryTags: []
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    let url = "/group/home/" + this.$route.params.id
    api.get(url, {}).then(
      (response) => {
        this.groupInfo = response.data
        this.$store.dispatch("setCurrentGroup", this.groupInfo)
        if (this.groupInfo.role != "Admin") {
          this.$router.push("/notFound")
          return
        }
        this.loadChecklist()
        this.loadBanners()
      },
      (error) => {
        this.$store.dispatch("setExecuting", false)
        this.error = error
        if (!error || !error.response) {
          this.$notify.error({
                               message: "Network connection problem. Please try refreshing the page." + error.response.data,
                               timeOut: 5000
                             })
        }
        if (error.response.status == 400) {
          //we could have flipped into maint mode; reload app
          window.location = "/"
        }
        if (error.response.status == 403) {
          this.$router.push("/notFound")
        }
        if (error.response.status == 404) {
          this.$router.push("/notFound")
        }
        if (error.response.status == 306) {
          window.location = error.response.data.url
        }
      }
    );
  },
  methods: {
    setCurrentView() {
      if (!this.checklist) return
      if (this.checklist.showChecklist) {
        if (!this.checklist.avatarSet) this.currentView = "avatar"
        else if (!this.checklist.bannerSet) this.currentView = "banner"
        else if (!this.checklist.hasCategories) this.currentView = "categories"
        else {
          this.currentView = "finalize"
          this.markComplete()
        }
      } else {
        this.currentView = "menu"
      }

    },
    saveTags() {
      let payload = {categories: this.categoryTags.join()}
      api.post("/group/saveCategories/" + this.groupInfo.vanityPath, payload).then(
        (details) => {
          this.checklist.hasCategories = true
          this.setCurrentView()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadBanners() {
      api.get("/group/banner/" + this.groupInfo.vanityPath, {}).then(
        (details) => {
          this.banners = details.data
        },
        (error) => {
          this.$notify.error({message: "Could not get banners at this time.", timeOut: 5000})
        })
    },
    openUpload(type) {
      this.uploadType = type
      this.showUpload = true
    },
    groupHome() {
      this.$router.push('/group/' + this.groupInfo.vanityPath)
    },
    uploadFile: async function (file) {
      this.showUpload = false
      let toUpload = file[0]
      await this.$store.dispatch("setExecuting", true)
      const reduce = require('image-blob-reduce')();
      if (toUpload.size >= 2000000) {
        await reduce.toBlob(toUpload, {max: 2000})
          .then(blob => {
            toUpload.file = blob
          })
      }

      let uploadResults = await api.groupUploadImage(this.groupInfo.id, toUpload)
      if (!uploadResults.success) {
        this.$notify.error({message: uploadResults.error, timeOut: 5000})
        await this.$store.dispatch("setExecuting", false)
        return
      }

      if (this.uploadType == "avatar") {
        api.post(`/group/uploadAvatar/${this.groupInfo.id}/?requestId=${uploadResults.uploadRequest.id}`, {}).then(
          (results) => {
            this.avatarUrl = results.data.url
            this.showUploadedAvatar = true
            this.showUpload = false
            this.$nextTick().then(() => {
              window.scrollTo(0, 0)
            })
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
      if (this.uploadType == "banner") {
        this.$store.dispatch("setExecuting", true)
        api.post(`/group/newBanner/${this.groupInfo.vanityPath}/?uploadOnly=true&requestId=${uploadResults.uploadRequest.id}`, {}).then(
          (results) => {
            let banner = {id: results.data.id, url: results.data.bannerUrl}
            this.banners.customImages.unshift(banner)
            this.$nextTick().then(() => {
              window.scrollTo(0, 0)
            })
          },
          (error) => {
            this.$notify.error({message: "Error uploading file.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    },
    rejectAvatar() {
      this.avatarUrl = null
      this.showUploadedAvatar = false
    },
    acceptAvatar() {
      this.checklist.avatarSet = true
      this.checklist.avatar = this.avatarUrl
      this.setCurrentView()
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
    },
    selectBanner: function (type, banner) {
      this.$store.dispatch("setExecuting", true)
      api.post("/group/banner/" + this.groupInfo.vanityPath, {bannerType: type, id: banner.id}).then(
        (details) => {
          this.checklist.bannerSet = true
          this.checklist.banner = banner.url
          this.setCurrentView()
        },
        (error) => {
          this.$notify.error({message: "Could not get banners at this time.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    markComplete() {
      this.$store.dispatch("setExecuting", true)
      api.get("/group/checklistComplete/" + this.groupInfo.vanityPath).then(
        (results) => {
          console.log("Complete")
        },
        (error) => {
          this.$notify.error({message: "Could not mark complete at this time.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    setGenericAvatar(id) {
      api.get("/group/setGenericAvatar/" + this.groupInfo.vanityPath + "?imageId=" + id).then(
        (response) => {
          this.$store.dispatch("setExecuting", false)
          this.checklist.avatarSet = true
          this.checklist.avatar = this.settings.staticImageUrl + '/default_group_avatar_' + id + '.jpg'
          this.setCurrentView()
          this.$nextTick().then(() => {
            window.scrollTo(0, 0)
          })
        },
        (error) => {
          console.log(this.error.response)
          this.$store.dispatch("setExecuting", false)
        }
      );
    },
    loadChecklist() {
      api.get("/group/checklistStatus/" + this.groupInfo.vanityPath).then(
        (response) => {
          this.checklist = response.data
          this.$store.dispatch("setExecuting", false)
          if (this.checklist.categories.length > 0) {
            this.categoryTags = this.checklist.categories.split(",").sort()
          } else this.categoryTags = []
          if (this.categoryTags.length == 1 && this.categoryTags[0] == "") this.categoryTags = []

          this.setCurrentView()
        },
        (error) => {
          console.log(this.error.response)
          this.$store.dispatch("setExecuting", false)
        }
      );
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 749px ) {
  .group-overlay-container {
    font-size: 175%;
    width: 84%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 1.75em;
  }

  .group-banner {
    margin-top: 64px;
    display: block;
    width: 100%;
    background-size: cover;
    padding-top: 165px;
    position: relative;
  }

  .group-overlay-name {
    padding-left: 10px;
  }

  .banner-edit {
    background-color: #ffffff;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 5000;
  }

}

@media screen and (min-width: 750px ) {
  .group-overlay-container {
    font-size: 2.5rem;
    padding-left: 1em;
    padding-right: 1em;
    margin-bottom: 30px;
  }

  .group-overlay-name {
    opacity: 1;
    font-size: 2.5rem;
    padding-left: 10px;
  }

  .group-banner {
    margin-top: 74px;
    display: block;
    width: 100%;
    background-size: cover;
    position: relative;
  }

  .group-banner-large {
    padding-top: 25%;
  }

  .group-banner-medium {
    padding-top: 15%;
  }

  .group-banner-small {
    padding-top: 10%;
  }

  .banner-edit {
    z-index: 2000;
    background-color: #ffffff;
    opacity: 0.8;
    position: absolute;
    top: 80px;
    right: 0;
    padding: 10px;
  }


}

.group-overlay-container {
  background-color: #ffffff;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  left: 0;
}

.banner-edit-overlay {
  background-color: #ffffff;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
  cursor: pointer;
}

</style>
